import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, IconButton, Tooltip } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'

const NAV_BUTTON_SX = {
  color: 'rgba(255, 255, 255, 0.55)',
  minWidth: 44,
  '&:hover': { color: '#fff' },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.15)' },
}

/**
 * The operator's own controls, and nothing else — the prize on the stage is all the audience needs
 * to read. Deliberately dim: it sits in the corner of a projection all evening.
 */
const StageHeader = ({
  stopIndex,
  prizeCount,
  isRolling,
  isFullscreen,
  canShowWinners,
  onShowWinners,
  onPrev,
  onNext,
  onToggleFullscreen,
}) => (
  <Box display='flex' justifyContent='space-between' alignItems='center' gap={1}>
    {/* Gated with the rest: leaving mid-draw abandons a roll the room is watching. */}
    <Button
      component={Link}
      to='/lucky-draw'
      disabled={isRolling}
      startIcon={<ChevronLeftIcon />}
      sx={NAV_BUTTON_SX}
    >
      BACK
    </Button>
    <Box display='flex' alignItems='center' gap={1}>
      {/* Puts the last draw's winners back on screen after they have been dismissed. */}
      <Button onClick={onShowWinners} disabled={!canShowWinners} sx={NAV_BUTTON_SX}>
        WINNERS
      </Button>
      <Button
        onClick={onPrev}
        disabled={isRolling || stopIndex === 0}
        startIcon={<ChevronLeftIcon />}
        sx={NAV_BUTTON_SX}
      >
        PREV
      </Button>
      <Button
        onClick={onNext}
        disabled={isRolling || stopIndex >= prizeCount - 1}
        endIcon={<ChevronRightIcon />}
        sx={NAV_BUTTON_SX}
      >
        NEXT
      </Button>
      <Tooltip title={isFullscreen ? 'Exit full screen' : 'Full screen'}>
        <IconButton onClick={onToggleFullscreen} sx={{ color: 'rgba(255, 255, 255, 0.55)' }}>
          {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  </Box>
)

export default StageHeader
